export default __webpack_public_path__ + "static/taskdefinition18-4cdbf20a3db50106e5785fdbbb5e4509.png";